import { combineReducers } from "redux";
import AppState from '../app/appState';
import PresenterState from '../presenter/presenterState';
import EmployeeState from "../employee/employeeState";
const rootReducer = combineReducers({AppState, PresenterState, EmployeeState});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;